import { render } from "./HeroPage.vue?vue&type=template&id=09a916ae&scoped=true"
import script from "./HeroPage.vue?vue&type=script&lang=js"
export * from "./HeroPage.vue?vue&type=script&lang=js"

import "./HeroPage.vue?vue&type=style&index=0&id=09a916ae&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a916ae"]])

export default __exports__